module.exports = __webpack_public_path__ + "static/img/new_in_transit.4df15c43.png";